import Vue from 'vue';
import Vuex from 'vuex';
import {requestPages} from '../requests/requestPages';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		title: 'Title of Vue Component',
		count: 0,
		loadedPages: null,
		products: [],
		rentals: null,
		searchText: null,
		searchCat: {},
		filterDropdown: {},
		chosenFilterEventType: {},
		chosenFilterDishType: {},
		chosenFilterPeople: {},
		chosenFilterPrice: {},
		tags: [],
		types: [],
		largestPrice: 0,
		largestServing: 0
	},
	mutations: {
		increment(state) {
			state.count++;
		},
		setPages(state, pages) {
			state.loadedPages = pages;
		},
		setCheckingResults(state, payload) {
			state.checkingResults = payload;
		},
		setProducts(state, products) {
			// if (state.products.length > 0) {
			// 	const arr1 = state.products;
			// 	const arr2 = products;
			// 	state.products = arr1.concat(arr2);
			// } else {
			// }
			state.products = products;
		},
		setTags(state, tags) {
			state.tags = tags;
		},
		setTypes(state, types) {
			state.types = types;
		},
		setLargestPrice(state, largestPrice) {
			state.largestPrice = largestPrice;
		},
		setLargestServing(state, largestServing) {
			state.largestServing = largestServing;
		},
		// setRentals(state, rentals) {
		// 	state.rentals = rentals;
		// },
		setSearchText(state, searchText) {
			state.searchText = searchText;
		},
		setSearchCat(state, searchCat) {
			state.searchCat = searchCat;
		},
		setFilterDropdown(state, filterDropdown) {
			state.filterDropdown = filterDropdown;
		},
		setChosenFilterEventType(state, chosenFilter) {
			state.chosenFilterEventType = chosenFilter;
		},
		setChosenFilterDishType(state, chosenFilter) {
			state.chosenFilterDishType = chosenFilter;
		},
		setChosenFilterPeople(state, chosenFilter) {
			state.chosenFilterPeople = chosenFilter;
		},
		setChosenFilterPrice(state, chosenFilter) {
			state.chosenFilterPrice = chosenFilter;
		},
	},
	actions: {
		setPages(vuexContext) {
			if (vuexContext.getters.getPages === null) requestPages(vuexContext);
		},
		async setProducts(vuexContext, payload) {
			//const type = {type: payload.type};
			await axios.post('/wp-json/fws/v1/get-products', payload)
				.then(response => {
					if (response.data !== 0) {
						vuexContext.commit('setProducts', response.data);
						// console.log(response.data);
					}
					return Promise.resolve(response);
				})
				.catch(error => {
					return Promise.reject(error);
				});
		},
		// setRentals(vuexContext) {
		// 	axios.post('/wp-json/fws/v1/get-rentals')
		// 		.then(response => {
		// 			console.log('rentals- ');
		// 			vuexContext.commit('setRentals', response.data);
		// 		})
		// 		.catch(error => console.log(error));
		// },
		setSearchProducts(vuexContext, payload) {
			axios.post('/wp-json/fws/v1/search-products/', payload)
				.then(response => {
					vuexContext.commit('setProducts', response.data);
				}).catch(error => console.log(error));
		},
		setSearchText(vuexContext, payload) {
			vuexContext.commit('setSearchText', payload);
		},
		setSearchCat(vuexContext, payload) {
			vuexContext.commit('setSearchCat', payload);
		},
		setTags(vuexContext, payload) {
			vuexContext.commit('setTags', payload);
		},
		setTypes(vuexContext, payload) {
			vuexContext.commit('setTypes', payload);
		},
		setLargestPrice(vuexContext, payload) {
			vuexContext.commit('setLargestPrice', payload);
		},
		setLargestServing(vuexContext, payload) {
			vuexContext.commit('setLargestServing', payload);
		},
		setFilterDropdown(vuexContext) {
			axios.post('/wp-json/fws/v1/filter-dropdowns')
				.then(response => {
					vuexContext.commit('setFilterDropdown', response.data);
				})
				.catch(error => console.log(error));
		},
		setChosenFilterEventType(vuexContext, payload) {
			vuexContext.commit('setChosenFilterEventType', payload);
		},
		setChosenFilterDishType(vuexContext, payload) {
			vuexContext.commit('setChosenFilterDishType', payload);
		},
		setChosenFilterPeople(vuexContext, payload) {
			vuexContext.commit('setChosenFilterPeople', payload);
		},
		setChosenFilterPrice(vuexContext, payload) {
			vuexContext.commit('setChosenFilterPrice', payload);
		},
	},
	getters: {
		getTitle(state) {
			return state.title;
		},
		getCount(state) {
			return state.count;
		},
		getPages(state) {
			return state.loadedPages;
		},
		getProducts(state) {
			return state.products;
		},
		// getRentals(state) {
		// 	return state.rentals;
		// },
		getSearchProducts(state) {
			return state.products;
		},
		getSearchText(state) {
			return state.searchText;
		},
		getSearchCat(state) {
			return state.searchCat;
		},
		getFilterDropdown(state) {
			return state.filterDropdown;
		},
		getChosenFilterEventType(state) {
			return state.chosenFilterEventType;
		},
		getChosenFilterDishType(state) {
			return state.chosenFilterDishType;
		},
		getChosenFilterPeople(state) {
			return state.chosenFilterPeople;
		},
		getChosenFilterPrice(state) {
			return state.chosenFilterPrice;
		},
		getTags(state) {
			return state.tags;
		},
		getTypes(state) {
			return state.types;
		},
		getLargestPrice(state) {
			return state.largestPrice;
		},
		getLargestServing(state) {
			return state.largestServing;
		}
	}
});
